<template>
  <div class="table-grid">
    <div
      v-if="isGridTable"
      class="table-grid__container"
      :style="gap === '12px' ? `grid-template-columns : repeat(${numCols}, 1fr); max-height: ${resizedMaxHeight};` :
         `grid-template-columns : repeat(${numCols}, 1fr); max-height: ${resizedMaxHeight}; column-gap: 0`"
    >
      <!--       header -->
      <grid-table-header-row :headers="headers" :num-cols="numCols" :color="loaderColor" :have-vuetify="haveVuetify">
        <slot v-for="(_, name) in $slots" :name="name" :slot="name"/>
        <template v-for="(_, name) in $scopedSlots" v-slot:[name]="slotData">
          <slot :name="name" v-bind="slotData"/>
        </template>
      </grid-table-header-row>
      <!--        body-->
      <template v-if="loadingData || loading">
        <div class="d-flex flex-row align-center" :style="`grid-column: span ${numCols}; min-height: 200px;`">
          <slot name="loading">
            <v-progress-linear v-if="haveVuetify" indeterminate :color="loaderColor"/>
            <template v-else>
              Loading...
            </template>
          </slot>
        </div>
      </template>
      <grid-table-empty-data :num-cols="numCols" v-else-if="dataRows.length === 0"/>
      <template v-else>
        <!--        <DynamicScroller-->
        <!--            v-if="useVirtualScroller"-->
        <!--            :items="dataRows"-->
        <!--            :min-item-size="sizeElementForVirtualScrollerValidated"-->
        <!--            class="scroller"-->
        <!--            :style="`height: ${maxTableHeightForScroller}; grid-column: span ${numCols};`"-->
        <!--        >-->
        <!--          <template v-slot="{ item, index, active }">-->
        <!--            <DynamicScrollerItem-->
        <!--                :item="item"-->
        <!--                :active="active"-->
        <!--                :size-dependencies="rowFields"-->
        <!--                :data-index="index"-->
        <!--            >-->
        <!--              <grid-table-body-row-->
        <!--                  :row="item"-->
        <!--                  :num-cols="numCols"-->
        <!--                  :paint-background="paintBackground"-->
        <!--                  :headers="headersForRows"-->
        <!--                  @row-action="rowAction($event,item)"-->
        <!--              >-->
        <!--&lt;!&ndash;                <slot v-for="(_, name) in $slots" :name="name" :slot="name">-->
        <!--                  1 - {{name}}-->
        <!--                </slot>&ndash;&gt;-->
        <!--                <template v-for="(_, name) in $scopedSlots" v-slot:[name]="slotData">-->
        <!--                  <slot v-if="useSlots" :name="name" v-bind="slotData"/>-->
        <!--                </template>-->
        <!--              </grid-table-body-row>-->
        <!--            </DynamicScrollerItem>-->
        <!--          </template>-->
        <!--        </DynamicScroller>-->
        <template>
          <grid-table-body-row
            v-for="(item, j) in dataRows"
            :row="item"
            :key="(item.id != null ? item.id  : j)"
            :num-cols="numCols"
            :paint-background="paintBackground"
            :headers="headersForRows"
            @row-action="rowAction($event,item)"
          >
            <slot v-for="(_, name) in $slots" :name="name" :slot="name"/>
            <template v-for="(_, name) in $scopedSlots" v-slot:[name]="slotData">
              <slot v-if="useSlots" :name="name" v-bind="slotData"/>
            </template>
          </grid-table-body-row>
        </template>
      </template>
    </div>
    <table v-else
           class="table-on-td"
           :style="`max-height: ${resizedMaxHeight};`"
    >
      <thead>
      <tr>
        <th
          v-for="(item, i) in headers" :key="i"
          :class="item.headerClass"
          :colspan="item.cols"
          :rowspan="item.rows"
          :ref="'table-header__cell-'+item.dataField"
          :style="`${item.headerStyles}`"
        >
          <slot :name="'header-'+item.dataField" :item="item">
            <span v-html="item.text"></span>
            <span
              class="d-flex align-center justify-center"
              v-if="item.sortable"
            >
                <template v-if="sort.header === item.dataField">

                </template>
                <template v-else>

                </template>
          </span>
          </slot>
        </th>
      </tr>
      </thead>
      <tbody>
      <template v-if="loadingData || loading">
        <tr>
          <td class="d-flex flex-row align-center" :colspan="numCols"
              :style="` min-height: 200px;`">
            <slot name="loading">
              <v-progress-linear v-if="haveVuetify" indeterminate :color="loaderColor"/>
              <template v-else>
                Loading...
              </template>
            </slot>
          </td>
        </tr>
      </template>
      <template v-else>
        <tr
          v-for="(row, j) in dataRows"
          class=""
          style=""
          @click="rowAction($event,row)"
          :key="(row.id != null ? row.id  : j)"
          @row-action="rowAction($event,row)"
        >
          <td
            v-for="cell in headersForRows"
            class=""
            :key="cell.dataField"
            :colspan="cell.cols"
            :rowspan="cell.rows"
            :class="[cell.class, painCell(row, cell)]"
            :style="`${typeof cell.styles === 'function' ? cell.styles(row) : cell.styles};`"
          >
            <slot v-if="useSlots" :name="cell.dataField" :row="row" :id="row.id != null ? row.id : Math.random()"
                  :cell="cell">
              <span v-html="cellData(row, cell)"></span>
            </slot>
            <span v-else v-html="cellData(row, cell)"></span>
          </td>
        </tr>
      </template>
      </tbody>
    </table>
  </div>
</template>

<script>

// import { DynamicScroller, DynamicScrollerItem} from 'vue-virtual-scroller'
import GridTableHeaderRow from "@/components/GridTable/GridTableHeaderRow";
import GridTableEmptyData from "@/components/GridTable/GridTableEmptyData";
import GridTableBodyRow from "@/components/GridTable/GridTableBodyRow";

export default {
  name: "GridTable",
  components: {
    // eslint-disable-next-line vue/no-unused-components
    GridTableBodyRow, GridTableEmptyData, GridTableHeaderRow,  /*DynamicScroller, DynamicScrollerItem*/
  },
  props: {
    headers: {
      type: [Array],
      required: true,
      default: () => []
    },
    typeTable: {
      type: String,
      default: 'grid',
      validator: (v) => {
        return ['grid', 'table'].includes(v)
      }
    },
    numCols: {
      type: [Number, String],
      required: true,
      default: 0
    },
    headersForRows: {
      type: [Array],
      required: true,
      default: () => []
    },
    maxTableHeight: {
      type: [String, Number],
      default: (window.screen.availHeight - 370 + 'px') ?? '550px',
    },
    loadingData: {
      type: Boolean,
      default: false
    },
    useSlots: {
      type: Boolean,
      default: true
    },
    dataRows: {
      type: Array,
      default: () => []
    },
    paintBackground: {
      type: [Function],
      default: () => {
      }
    },
    importsComponents: {
      type: [Array, Object]
    },
    loaderColor: {
      type: String,
      default: '#00599b'
    },
    gap: {
      type: String,
      default: '12px'
    },
    useVirtualScroller: {
      type: Boolean,
      default: false
    },
    sizeElementForVirtualScroller: {
      type: [String, Number],
      default: 40
    }
  },
  computed: {
    sizeElementForVirtualScrollerValidated() {
      return Number.parseInt(this.sizeElementForVirtualScroller)
    },
    maxTableHeightForScroller() {
      return window.screen.availHeight - 375 + 'px'
    },
    rowFields() {
      return this.headersForRows.map(el => ('item.' + el.dataField))
    },
    isGridTable() {
      return this.typeTable === 'grid'
    },
    haveVuetify() {
      return !!this.$vuetify
    }
  },
  data() {
    return {
      localHeaders: this.headers,
      loading: false,
      reseizing: false,
      resizedMaxHeight: null,
      sort: {header: null, type: 'asc'}
    }
  },
  watch: {
    async headers(newValue) {
      // console.log(this.$refs['grid-table'])
      // await this.$refs['grid-table'].scrollIntoView({block: "start", inline: "nearest"});
      this.loading = true;
      this.localHeaders = newValue;
      this.initClass();
      // await this.setTopPositions();
      this.loading = false;
    }
  },
  mounted() {
    // this.setTopPositions();
    this.initClass();
    this.resizeMaxHeight();
    window.addEventListener('resize', this.resizeMaxHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeMaxHeight)
    // window.removeEventListener('resize', this.setTopPositions)
  },
  methods: {
    resizeMaxHeight() {
      if (this.reseizing) return;
      this.reseizing = true;
      const height = (window.screen.availHeight - 350) + 'px';
      if (this.maxTableHeight > height)
        this.resizedMaxHeight = height;
      else
        this.resizedMaxHeight = this.maxTableHeight;
      this.reseizing = false;
    },
    initClass() {
      if (!this.isGridTable && !this.useVirtualScroller) return;
      const style = document.createElement('style');
      style.innerHTML = `.vue-recycle-scroller__item-view{
            display: grid;
            grid-template-columns: repeat(${this.numCols}, 1fr)!important;
            grid-column: span ${this.numCols} / auto;
            }
            .vue-recycle-scroller__item-view div:first-child{
            display: grid;
            grid-template-columns: repeat(${this.numCols}, 1fr)!important;
            grid-column: span ${this.numCols} / auto;
            }
            `;
      document.getElementsByTagName('head')[0].appendChild(style);
      // this.$refs["recycle-scroller"].classList.add('cssClass');
    },
    rowAction(e, row) {
      this.$emit('row-action', {e: e, row: row})
    },
    cellData(row, cell) {
      return cell.template ? cell.template(row) : row[cell.dataField]
    },
    calcStylesForRowCell(row, cell) {
      return `${typeof cell.styles === 'function' ? cell.styles(row) : cell.styles};` + `grid-column: span ${cell.colsDataCalc ? cell.colsDataCalc(row, cell) : cell.cols}; grid-row: span ${cell.rowsDataCalc ? cell.rowsDataCalc(row) : cell.rowsData};`
    },
    // eslint-disable-next-line no-unused-vars
    painCell(row, cell) {
      if (this.paintBackground(row))
        return this.paintBackground(row)();
    },
  },
}
</script>

<style scoped>
</style>